import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pad10 with_white_bg text-left rad20"
}
const _hoisted_2 = {
  key: 0,
  class: ""
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "fw600 mt2 fs18 fl ml10",
  style: {}
}, "Zoom設定", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "w100 pad5"
}
const _hoisted_6 = {
  class: "w100",
  style: {}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "ホスト入室前設定", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  class: "w100",
  style: {}
}
const _hoisted_10 = { class: "fw600" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = { class: "w100 mt20" }
const _hoisted_14 = { class: "fw600" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { class: "mt10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconGear = _resolveComponent("IconGear")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_ZoomSelectContent = _resolveComponent("ZoomSelectContent")!

  return (_ctx.rcm && _ctx.rcm.room)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.rcm.room_setting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_IconGear, {
                width: 28,
                class: "fl pointer"
              }),
              _hoisted_3,
              _createElementVNode("p", {
                class: "fr skyblue pointer fs12",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDetailContent && _ctx.showDetailContent(...args)))
              }, "詳細設定"),
              _hoisted_4,
              (_ctx.showDetail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createVNode(_component_SelectTag, {
                        name: "cancel_span_names",
                        id: "select_cancel_span_names",
                        class: "fl fs14 roundForm",
                        style: {"min-width":"220px","height":"50px"},
                        options: (_ctx.SelectUtil.availableZoomSettingJoinBeforeHost || []).map(seldic => seldic.name),
                        defaultOption: _ctx.availableZoomSettingJoinBeforeHost,
                        needUnselect: false,
                        onSelectValue: _ctx.selectAvailableZoomSettingJoinBeforeHost
                      }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                      _hoisted_8
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h5", _hoisted_10, [
                        _createTextVNode(" パスコード設定 "),
                        _createVNode(_component_IconHelp, {
                          width: 18,
                          tooltipText: `通常は6桁のパスコードを発行します。\nセキュアな設定に変更すると、記号を含む10桁の英数字（大文字・小文字混合）を生成するようになります。\n\nパスコードを設定しない場合は、Zoomアカウントのデフォルトのパスコード（PMI）を利用します。`,
                          detailUrl: null,
                          style: {"margin-top":"-3px","margin-right":"5px"}
                        })
                      ]),
                      _createVNode(_component_SelectTag, {
                        name: "cancel_span_names",
                        id: "select_cancel_span_names",
                        class: "fl fs14 roundForm",
                        style: {"min-width":"220px","height":"50px"},
                        options: (_ctx.SelectUtil.zoomPasscodeTypes || []).map(seldic => seldic.name),
                        defaultOption: _ctx.zoomSettingDefaultPasscodeType,
                        needUnselect: false,
                        onSelectValue: _ctx.selectZoomSettingPasscodeType
                      }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                      _hoisted_11
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_12
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h5", _hoisted_14, [
              _createTextVNode(" Zoom紐付け "),
              _createVNode(_component_IconHelp, {
                width: 18,
                tooltipText: `確定時に利用するZoomアカウントを設定します。上から順に空いているZoomアカウントを発行します。\n\nグループごとに利用するZoomアカウントを設定する場合は、\n調整カレンダーのグループの横にある三点リーダーからZoom紐付けを行ってください。\n
                設定したZoomアカウントが同時間に利用されている場合は、\n空き日程として表示されなくなります。`,
                detailUrl: null,
                style: {"margin-top":"-3px","margin-right":"5px"}
              })
            ]),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_ZoomSelectContent, {
              zoomLoctags: _ctx.zoomLoctags,
              sZooms: _ctx.selectedZooms,
              unZooms: _ctx.unselectedZooms,
              onUpdate: _ctx.updateZoomAccounts
            }, null, 8, ["zoomLoctags", "sZooms", "unZooms", "onUpdate"])
          ]),
          _hoisted_17
        ]),
        _hoisted_18
      ]))
    : _createCommentVNode("", true)
}